import React, { useContext, useEffect } from "react";
import { Redirect } from "react-router";

import { AuthContext } from "../../contexts/authContext";
import { defaultMisPath } from "../../services/loginRedirect";

const LoginMainArea = () => {
  const { currentUser, mustChangePassword } = useContext(AuthContext);

  useEffect(() => {
    if (!currentUser) {
      window.location.replace("/login.html");
    }
  }, [currentUser]);

  if (currentUser) return <Redirect to={defaultMisPath(mustChangePassword)} />;

  return null;
};

export default LoginMainArea;
